import { render, staticRenderFns } from "./RegisterType.vue?vue&type=template&id=09e35fae&scoped=true"
import script from "./RegisterType.vue?vue&type=script&lang=js"
export * from "./RegisterType.vue?vue&type=script&lang=js"
import style0 from "./RegisterType.vue?vue&type=style&index=0&id=09e35fae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09e35fae",
  null
  
)

export default component.exports